import { render } from "./UserHistoryGame.vue?vue&type=template&id=6b5abe8c&scoped=true&ts=true"
import script from "./UserHistoryGame.vue?vue&type=script&lang=ts"
export * from "./UserHistoryGame.vue?vue&type=script&lang=ts"

import "./UserHistoryGame.vue?vue&type=style&index=0&id=6b5abe8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5abe8c"]])

export default __exports__